window.okeConnectApi.recommendedProductMounted = (sectionContent, product) => {
  const addButton = sectionContent.querySelector('button.c-addToCart');
  if (addButton && !sectionContent.loaded) {
    sectionContent.loaded = true;
    const learnMoreButton =
      `<div class="c-resultLearnMore">
        <a class="c-resultButton-primary c-button c-resultButton" style="width: 100%;" href='` +
      product.url +
      `' target="_blank">Learn More</a>
        </div>`;
    addButton.insertAdjacentHTML('afterEnd', learnMoreButton);
    const addText = addButton.getElementsByClassName('c-addToCart-text')[0];
    if (addText) {
      addText.innerHTML = 'Add to bag';
    }
  }
  sectionContent.parentElement.style = '';
};

document.addEventListener('oke_connect_cart_itemVariantAdded', async (event) => {
  setTimeout(() => document.querySelector('a#cart-icon-bubble').click(), 1500);
});

let observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          console.log('new', node);
          node
            .querySelectorAll('.c-startPanel-title, .c-startPanel-subtitle, .c-questions-header-title')
            .forEach((node) => {
              node.innerHTML = node.innerText;
            });
        }
      });
    }
  });
});

let config = { childList: true, subtree: true };
observer.observe(document.querySelector('[oke-quiz]'), config);
